import {injectable} from 'inversify';

import type {CoachHistoryModel} from './CoachHistory.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class CoachHistoryController extends BaseController<CoachHistoryModel> {
  constructor() {
    super();
  }
}
